/**
 * Interactive behaviors for legacy ported landing pages:
 * - Accordions (health-insights, science-and-research)
 * - Tabs (how-it-works)
 */
(function () {
  'use strict';

  function initAccordions() {
    document.addEventListener('click', function (e) {
      const header = e.target.closest('.accordion--item--header');
      if (!header) return;

      const item = header.closest('.accordion--item');
      if (!item) return;

      const isExpanded = header.getAttribute('aria-expanded') === 'true';
      const content = item.querySelector('.accordion--item--content');

      header.setAttribute('aria-expanded', String(!isExpanded));
      item.classList.toggle('accordion--item--open', !isExpanded);

      if (content) {
        content.style.display = isExpanded ? 'none' : 'block';
        content.setAttribute('aria-hidden', String(isExpanded));
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      const header = e.target.closest('.accordion--item--header');
      if (!header) return;

      e.preventDefault();
      header.click();
    });
  }

  function initHowItWorksTabs() {
    document.addEventListener('click', function (e) {
      const tab = e.target.closest('.how-it-works-steps--tab');
      if (!tab) return;

      const tablist = tab.closest('.how-it-works-steps--tablist');
      if (!tablist) return;

      const container = tab.closest('.how-it-works-steps--tabs-container') || document;
      const allTabs = Array.from(tablist.querySelectorAll('.how-it-works-steps--tab'));
      const index = allTabs.indexOf(tab);
      if (index === -1) return;

      // Update tabs state
      allTabs.forEach(function (t, i) {
        const isSelected = i === index;
        t.setAttribute('aria-selected', String(isSelected));
        t.setAttribute('tabindex', isSelected ? '0' : '-1');
      });

      // Update panels state
      const panels = container.querySelectorAll('.how-it-works-steps--panel');
      panels.forEach(function (panel, i) {
        if (i === index) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      // Update image state
      const images = container.querySelectorAll('.how-it-works-steps--item-image');
      images.forEach(function (img, i) {
        img.style.display = i === index ? 'block' : 'none';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAccordions();
      initHowItWorksTabs();
    });
  } else {
    initAccordions();
    initHowItWorksTabs();
  }
})();
